import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import rootReducer from './reducers';

const store = createStore(rootReducer, applyMiddleware(thunk));
function Store({ children }) {
  return <Provider store={store}>{children}</Provider>;
}

export default Store;
